import { render, staticRenderFns } from "./RosTransfer.vue?vue&type=template&id=04c9ef07&"
import script from "./RosTransfer.vue?vue&type=script&lang=js&"
export * from "./RosTransfer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports